import { CurrencyPipe } from '@angular/common';
import { Pipe, PipeTransform, inject } from '@angular/core';
import { localStorageAccessConstant } from 'src/app/constants/LocalStorageAccessConstant';
import { StorageService } from 'src/app/services/security/storage.service';

@Pipe({
  name: 'currencyPresicion'
})
export class CurrencyPresicionPipe implements PipeTransform {

    private currencyPipe = inject(CurrencyPipe);
    private ls = inject(StorageService);

  transform(value: any, args?: any): any {
    var decimalPrecision = Number(this.ls.get(localStorageAccessConstant.decimalPrecision));
    var decimlaPrecisionStringForCurrency = Number.isFinite(decimalPrecision) && decimalPrecision > 0 ? `1.${decimalPrecision}-${decimalPrecision}` : '1.4-4';

    return this.currencyPipe.transform(value, 'USD', 'symbol', decimlaPrecisionStringForCurrency);
  }

}
